<template>
  <div class="col-md-4 shadow">
    <vs-list>
      <vs-list-item
        v-for="(author, index) in authors"
        :key="index"
        icon="description"
        :title="author.usuarioAutorNombre"
        subtitle="Autor"
      />
    </vs-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConventionAuthors',
  computed: {
    ...mapGetters('Dnts', ['detailsFile']),
    authors() {
      return this.detailsFile.docDigitalAutores;
    }
  }
};
</script>

<style>

</style>
